/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React, { useState } from 'react';
import { bindActionCreators } from 'redux';
import {
    object, string, array, shape, bool, func,
} from 'prop-types';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import withStyles from '@material-ui/core/styles/withStyles';
import LazyLoad from 'react-lazyload';
import Button from '@material-ui/core/Button';
import Caret from '@material-ui/icons/ArrowForwardIos';
import { useUIDSeed } from 'react-uid';
import ReactMarkdown from 'react-markdown';
import { getPresentationFamily } from '../../../../../state/ducks/App/ducks/Config/Config-Selectors';
import generateValidCss from '../../../../helpers/contentstack/generateValidCss';
import Copy from '../../Copy';
import { trackEvent } from '../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';
import { getBrand } from '../../../../../state/ducks/App/ducks/Brand/Brand-Selectors';

/*
    TODO: Create ability to add sashes and dot-whacks.
          Create mobile version
          Define # per row (maybe unnecessary)
*/
const styles = (theme) => ({
    nUp: {
        width: '95%',
        margin: '20px auto',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        '& *:focus': {
            outline: 'none',
        },
    },
    header: theme.palette.nup?.header,
    panel: {
        height: 'auto',
        textDecoration: 'none',
        textAlign: 'center', // TODO: needs to be adjustable in CMS> HD is not centered
        display: 'flex',
        width: '45%',
        alignContent: 'top',
    },
    plaPanel: {
        width: '100%',
    },
    nupContent: {
    },
    root: {
        boxSizing: 'border-box',
        padding: theme.spacing(3, 0, 0, 0),
    },
    containerLink: {
        textDecoration: 'none',
    },
    imageContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        transition: 'all .3s',
        '& img': {
            minHeight: '160px',
        },
    },
    plaimageContainer: {
        '& img': {
            minHeight: 'unset',
        },
    },
    imageFixedWidth: {
        maxWidth: '240px',
    },
    messageWrapper: {
        padding: '10px 0',
        width: '100%',
        '& u': {
            fontSize: '0.7em',
        },
        '& p': {
            margin: '0 auto 10px',
        },
    },
    plamessageWrapper: {
        fontSize: '14px',
        lineHeight: '21px',
        letterSpacing: '0.7px',
        textTransform: 'uppercase',
        fontWeight: 'normal',
        textAlign: 'left',
    },
    messageWrapperTab: {
        width: '80%',
        margin: '0 auto',
        padding: '10px',
        '& u': {
            fontSize: '0.7em',
        },
    },
    cta: {
        boxSizing: 'border-box',
        display: 'block',
        margin: '0 auto',
        fontSize: '18px',
        fontWeight: '800',
        borderRadius: '2px',
    },
    btnStyle: {
        textDecoration: 'none',
        fontSize: '14px',
        '&:hover': {
            backgroundColor: 'transparent',
        },
    },
    circleMask: {
        borderRadius: '50%',
    },
    viewMoreWrapper: {
        width: 'calc(100vw)',
        bottom: '0',
        height: '40px',
        display: 'block',
        position: 'relative',
    },
    viewMoreGradientWrapper: {
        left: '0',
        width: 'calc(100vw)',
        bottom: '0',
        height: '200px',
        display: 'block',
        position: 'absolute',
        backgroundImage: 'linear-gradient(to bottom, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, .9) 60%)',
    },
    viewMore: {
        left: 'calc(50% - 0px)',
        color: theme.palette.common?.white,
        width: 'calc(35vw)',
        transform: 'translate(-50%, 0)',
        fontSize: '16px',
        fontWeight: '700',
        borderRadius: '5px',
        backgroundColor: theme.palette.text?.primary,
        lineHeight: '1.75',
        textTransform: 'uppercase',
        border: '0',
        cursor: 'pointer',
        outline: 'none',
        position: 'absolute',
        bottom: '0px',
        userSelect: 'none',
    },
    nUpLess: {
        maxWidth: '1400px',
        overflow: 'hidden',
        maxHeight: '900px',
        position: 'relative',
        padding: '0 10px 15px',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
    },
    titleStyle: {
        display: 'block',
        fontSize: '1.375rem',
        textAlign: 'center',
        fontFamily: 'BebasNeue',
        fontWeight: 'normal',
        lineHeight: '24px',
        marginBottom: '30px',
        letterSpacing: '1.3px',
        paddingTop: '20px',
        width: '100%',
    },
    Standard: theme.palette.nup?.Standard,
    Medium: theme.palette.nup?.Medium,
    Small: theme.palette.nup?.Small,
});
const fontFamilyParsed = (fontData) => {
    if (!fontData) return '';
    const fontArr = fontData.split(':');
    if (fontArr?.[1]) {
        return fontArr[1].replace(';', '');
    }
    return '';
};
const detailsAsObj = (promo) => {
    const data = [
        {
            details_link: {
                details_link: promo,
                presentation: 'Single Line',
            },
        },
    ];
    return data;
};
const NUpSimpleMobile = ({
    classes, headingAlignment, data, presentation_family, isBot, track, brand,
}) => {
    const [expanded, setExpanded] = useState(true);
    if (data.reference?.[0]) {
        const nup = data.reference[0];
        const itemList = nup.entry;
        const seed = useUIDSeed();
        const caretIcon = <Caret>content</Caret>;
        const arrowPLAIcon = (
            <img
                className="arrow"
                src="https://images.contentstack.io/v3/assets/blt4454dc0093319d35/bltaf23a429ab1fcc5a/634424651882bd10b7915839/cta-icon2x-4b14996f471bc2b23c01c5d8d54a1888.png"
                alt="arrow-icon"
                style={{
                    maxWidth: '16px',
                    height: '10px',
                    paddingLeft: '3%',
                    verticalAlight: 'middle',
                }}
            />
        );
        let messageWrapper = `${classes.messageWrapper} ${(brand?.code === 'PLA') ? classes.plamessageWrapper : ''}`;
        const buttonIcon = (brand?.code === 'PLA') ? arrowPLAIcon : caretIcon;
        const plaPanelStyle = (brand?.code === 'PLA') ? classes.plaPanel : '';
        const imageContainerStyle = (brand?.code === 'PLA') ? classes.plaimageContainer : '';
        const arrowBtnStyle = (brand?.code === 'PLA') ? classes.btnStyle : '';
        if (nup.styles.message_bg_style === 'Tab') { messageWrapper = classes.messageWrapperTab; }
        return (
            <div className={(presentation_family === 'food' && expanded && nup?.entry?.length > 6) ? classes.nUpLess : classes.nUp} data-container="Nup Simple">
                {nup.heading ? <h3 className={classes.header} style={{ textAlign: headingAlignment }}>{nup.heading}</h3> : null}
                {(brand?.code === 'PLA') ? (<h2 className={classes.titleStyle}>{nup?.title}</h2>) : ''}
                {
                    itemList.map((panelItem) => (
                        <>
                            <Link
                                key={seed(panelItem)}
                                anchor=""
                                to={panelItem.linking?.link?.href}
                                title={panelItem.linking?.link?.title}
                                className={`${classes.panel} ${plaPanelStyle}`}
                                onClick={() => {
                                    track({
                                        eventCategory: panelItem?.linking?.tracking_event_category || '',
                                        eventAction: panelItem?.linking?.tracking_event_action || '',
                                        eventLabel: panelItem?.linking?.tracking_event_label || '',
                                        eventName: 'feature_interaction', // Requird for GA4 feature_click
                                    });
                                }}
                                target={panelItem.linking?.link?.href?.indexOf('greenhouse') > -1 ? '_blank' : ''}
                            >
                                {panelItem.background_image || panelItem.background_image_mobile
                                    ? (
                                        <>
                                            <div
                                                className={`${classes.imageContainer} ${imageContainerStyle}`}
                                            >
                                                {isBot && <img src={panelItem.background_image_mobile?.url || panelItem.background_image?.url} alt={panelItem.background_image?.filename || panelItem.background_image_mobile?.filename} isBot="true" />}
                                                <LazyLoad>
                                                    <img src={panelItem.background_image_mobile?.url || panelItem.background_image?.url} alt={panelItem.background_image?.filename || panelItem.background_image_mobile?.filename} style={{ width: '100%' }} />
                                                </LazyLoad>
                                                <div
                                                    className={messageWrapper}
                                                    message=""
                                                    style={{
                                                        fontSize: `${nup.styles?.font_size}em`,
                                                        minHeight: `${nup.styles?.message_background_height}px`,
                                                        fontFamily: fontFamilyParsed(nup.styles?.copy_font),
                                                        color: nup.styles?.copy_color?.color,
                                                    }}
                                                >
                                                    {panelItem.copy && panelItem.copy.map((k) => <ReactMarkdown source={k} />)}
                                                    {panelItem.details_link && <Copy data={detailsAsObj(panelItem.details_link)} />}
                                                    {panelItem.cta_copy && (
                                                        <Button
                                                            className={arrowBtnStyle}
                                                            text
                                                            endIcon={buttonIcon}
                                                            style={{
                                                                fontFamily: fontFamilyParsed(nup.styles?.copy_font),
                                                            }}
                                                        >{panelItem.cta_copy}
                                                        </Button>
                                                    )}
                                                </div>
                                            </div>
                                        </>
                                        /* Added Copy components instead of manual switch case
                                        to avoid code repetition and to add more functionality to n-up panel.
                                        We can use Panel component directly but background image logic has not been implemented in it yet */
                                    )
                                    : (
                                        <div className={classes[data?.reference[0]?.presentation_style]} style={generateValidCss(panelItem.container_attributes, true)}>
                                            <Copy data={panelItem.message_collection} />
                                        </div>
                                    )}
                            </Link>
                        </>
                    ))
                }
                {presentation_family === 'food' && nup?.entry?.length > 6 && (
                    <div className={expanded ? classes.viewMoreGradientWrapper : classes.viewMoreWrapper}>
                        <button type="button" className={classes.viewMore} onClick={() => { setExpanded(!expanded); }} onKeyDown={() => { }}>
                            {expanded ? <span>View More</span> : <span>View Less</span>}
                        </button>
                    </div>
                )}
            </div>
        );
    }
    return <>n_up_simple not loaded correctly</>;
};
NUpSimpleMobile.propTypes = {
    data: shape({
        entry: shape({
            linking: object,
            copy: array,
            cta_copy: array,
            background_image: object,
            background_image_mobile: object,
        }).isRequired,
        styles: object,
    }).isRequired,
    classes: object.isRequired,
    headingAlignment: string.isRequired,
    presentation_family: string.isRequired,
    isBot: bool.isRequired,
    track: func.isRequired,
    brand: shape({
        code: string,
    }).isRequired,
};

const mapDispatchToProps = (dispatch) => ({
    track: bindActionCreators(trackEvent, dispatch),
});

const mapStateToProps = (state) => ({
    presentation_family: getPresentationFamily(state),
    brand: getBrand(state),
});

const enhance = compose(
    withStyles(styles),
    connect(mapStateToProps, mapDispatchToProps),
);
export default enhance(NUpSimpleMobile);
